/* Generated by tools/gen_modules_catalog.py - do not edit by hand. Re-run after the SQL or services change. */
export interface ModTable { schema: string; table: string; route: string; label: string; ops: string; enums: Record<string, string[]> }
export interface ModDef { key: string; title: string; group: string; icon: string; tables: ModTable[] }
export const MODULE_CATALOG: ModDef[] = [
 {
  "key": "spa",
  "title": "Spa & Wellness",
  "group": "Guest services",
  "icon": "Spa",
  "tables": [
   {
    "schema": "spa",
    "table": "Facility",
    "route": "spa/spa/facility",
    "label": "Facility",
    "ops": "All",
    "enums": {
     "FacilityType": [
      "SPA",
      "SALON",
      "GYM",
      "POOL",
      "THERMAL",
      "STUDIO"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "TreatmentRoom",
    "route": "spa/spa/treatment-room",
    "label": "Treatment Room",
    "ops": "All",
    "enums": {
     "RoomKind": [
      "SINGLE",
      "COUPLES",
      "WET",
      "HYDRO",
      "RELAX",
      "SALON_CHAIR"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "TreatmentCategory",
    "route": "spa/spa/treatment-category",
    "label": "Treatment Category",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "Treatment",
    "route": "spa/spa/treatment",
    "label": "Treatment",
    "ops": "All",
    "enums": {
     "GenderRestriction": [
      "NONE",
      "FEMALE_ONLY",
      "MALE_ONLY"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "Therapist",
    "route": "spa/spa/therapist",
    "label": "Therapist",
    "ops": "All",
    "enums": {
     "Gender": [
      "F",
      "M",
      "X"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "TherapistSkill",
    "route": "spa/spa/therapist-skill",
    "label": "Therapist Skill",
    "ops": "All",
    "enums": {
     "Level": [
      "TRAINEE",
      "QUALIFIED",
      "SENIOR",
      "MASTER"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "TherapistShift",
    "route": "spa/spa/therapist-shift",
    "label": "Therapist Shift",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "TreatmentPackage",
    "route": "spa/spa/treatment-package",
    "label": "Treatment Package",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "TreatmentPackageItem",
    "route": "spa/spa/treatment-package-item",
    "label": "Treatment Package Item",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "ClientPackage",
    "route": "spa/spa/client-package",
    "label": "Client Package",
    "ops": "All",
    "enums": {
     "Status": [
      "ACTIVE",
      "EXPIRED",
      "EXHAUSTED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "Appointment",
    "route": "spa/spa/appointment",
    "label": "Appointment",
    "ops": "All",
    "enums": {
     "Status": [
      "BOOKED",
      "CONFIRMED",
      "CHECKED_IN",
      "IN_SERVICE",
      "COMPLETED",
      "CANCELLED",
      "NO_SHOW"
     ],
     "Source": [
      "FRONTDESK",
      "ONLINE",
      "GUEST_APP",
      "CONCIERGE",
      "PHONE",
      "WALK_IN"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "AppointmentItem",
    "route": "spa/spa/appointment-item",
    "label": "Appointment Item",
    "ops": "All",
    "enums": {
     "Status": [
      "BOOKED",
      "IN_SERVICE",
      "COMPLETED",
      "CANCELLED",
      "NO_SHOW"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "MembershipPlan",
    "route": "spa/spa/membership-plan",
    "label": "Membership Plan",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "Membership",
    "route": "spa/spa/membership",
    "label": "Membership",
    "ops": "All",
    "enums": {
     "Status": [
      "ACTIVE",
      "PAUSED",
      "CANCELLED",
      "EXPIRED"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "ClientHealthNote",
    "route": "spa/spa/client-health-note",
    "label": "Client Health Note",
    "ops": "All",
    "enums": {
     "NoteType": [
      "CONTRAINDICATION",
      "ALLERGY",
      "INJURY",
      "PREGNANCY",
      "PREFERENCE",
      "OTHER"
     ],
     "Severity": [
      "INFO",
      "CAUTION",
      "DO_NOT_TREAT"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "Product",
    "route": "spa/spa/product",
    "label": "Product",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "spa",
    "table": "ProductSale",
    "route": "spa/spa/product-sale",
    "label": "Product Sale",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "PAID",
      "ROOM_CHARGED",
      "VOID"
     ]
    }
   },
   {
    "schema": "spa",
    "table": "ProductSaleLine",
    "route": "spa/spa/product-sale-line",
    "label": "Product Sale Line",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "golf",
  "title": "Golf",
  "group": "Guest services",
  "icon": "Golf",
  "tables": [
   {
    "schema": "golf",
    "table": "Course",
    "route": "golf/golf/course",
    "label": "Course",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "golf",
    "table": "CourseHole",
    "route": "golf/golf/course-hole",
    "label": "Course Hole",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "golf",
    "table": "TeeSheetTemplate",
    "route": "golf/golf/tee-sheet-template",
    "label": "Tee Sheet Template",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "golf",
    "table": "TeeTime",
    "route": "golf/golf/tee-time",
    "label": "Tee Time",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "HELD",
      "BOOKED",
      "BLOCKED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "Rate",
    "route": "golf/golf/rate",
    "label": "Rate",
    "ops": "All",
    "enums": {
     "GuestType": [
      "HOUSE",
      "VISITOR",
      "MEMBER",
      "MEMBER_GUEST",
      "JUNIOR",
      "TWILIGHT"
     ],
     "DayType": [
      "WEEKDAY",
      "WEEKEND",
      "HOLIDAY",
      "ANY"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "Membership",
    "route": "golf/golf/membership",
    "label": "Membership",
    "ops": "All",
    "enums": {
     "MembershipType": [
      "FULL",
      "WEEKDAY",
      "SOCIAL",
      "JUNIOR",
      "CORPORATE",
      "SENIOR"
     ],
     "Status": [
      "ACTIVE",
      "SUSPENDED",
      "EXPIRED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "Booking",
    "route": "golf/golf/booking",
    "label": "Booking",
    "ops": "All",
    "enums": {
     "Status": [
      "BOOKED",
      "CHECKED_IN",
      "PLAYING",
      "COMPLETED",
      "CANCELLED",
      "NO_SHOW"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "BookingPlayer",
    "route": "golf/golf/booking-player",
    "label": "Booking Player",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "golf",
    "table": "Equipment",
    "route": "golf/golf/equipment",
    "label": "Equipment",
    "ops": "All",
    "enums": {
     "EquipmentType": [
      "CART",
      "CLUBS",
      "TROLLEY",
      "RANGEFINDER",
      "SHOES",
      "BALLS"
     ],
     "Status": [
      "AVAILABLE",
      "IN_USE",
      "MAINTENANCE",
      "RETIRED"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "EquipmentRental",
    "route": "golf/golf/equipment-rental",
    "label": "Equipment Rental",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "golf",
    "table": "Tournament",
    "route": "golf/golf/tournament",
    "label": "Tournament",
    "ops": "All",
    "enums": {
     "Format": [
      "STROKE",
      "STABLEFORD",
      "SCRAMBLE",
      "MATCH",
      "BEST_BALL"
     ],
     "Status": [
      "PLANNING",
      "OPEN",
      "IN_PROGRESS",
      "COMPLETED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "golf",
    "table": "TournamentEntry",
    "route": "golf/golf/tournament-entry",
    "label": "Tournament Entry",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "activities",
  "title": "Tours, Activities & Kids Club",
  "group": "Guest services",
  "icon": "Activities",
  "tables": [
   {
    "schema": "act",
    "table": "ActivityCategory",
    "route": "activities/act/activity-category",
    "label": "Activity Category",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "ActivityOperator",
    "route": "activities/act/activity-operator",
    "label": "Activity Operator",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "Activity",
    "route": "activities/act/activity",
    "label": "Activity",
    "ops": "All",
    "enums": {
     "Difficulty": [
      "EASY",
      "MODERATE",
      "HARD",
      "EXTREME"
     ]
    }
   },
   {
    "schema": "act",
    "table": "ActivityGuide",
    "route": "activities/act/activity-guide",
    "label": "Activity Guide",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "ActivityResource",
    "route": "activities/act/activity-resource",
    "label": "Activity Resource",
    "ops": "All",
    "enums": {
     "ResourceType": [
      "EQUIPMENT",
      "VEHICLE",
      "VENUE",
      "BOAT",
      "OTHER"
     ]
    }
   },
   {
    "schema": "act",
    "table": "ActivityResourceRequirement",
    "route": "activities/act/activity-resource-requirement",
    "label": "Activity Resource Requirement",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "ActivitySession",
    "route": "activities/act/activity-session",
    "label": "Activity Session",
    "ops": "All",
    "enums": {
     "Status": [
      "SCHEDULED",
      "CONFIRMED",
      "IN_PROGRESS",
      "COMPLETED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "act",
    "table": "Waiver",
    "route": "activities/act/waiver",
    "label": "Waiver",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "ActivityBooking",
    "route": "activities/act/activity-booking",
    "label": "Activity Booking",
    "ops": "All",
    "enums": {
     "Status": [
      "BOOKED",
      "CONFIRMED",
      "CHECKED_IN",
      "COMPLETED",
      "CANCELLED",
      "NO_SHOW"
     ]
    }
   },
   {
    "schema": "act",
    "table": "ActivityParticipant",
    "route": "activities/act/activity-participant",
    "label": "Activity Participant",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "WaiverSignature",
    "route": "activities/act/waiver-signature",
    "label": "Waiver Signature",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "ActivityPackageInclusion",
    "route": "activities/act/activity-package-inclusion",
    "label": "Activity Package Inclusion",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "KidsClub",
    "route": "activities/act/kids-club",
    "label": "Kids Club",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "KidsClubEnrollment",
    "route": "activities/act/kids-club-enrollment",
    "label": "Kids Club Enrollment",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "act",
    "table": "KidsClubAttendance",
    "route": "activities/act/kids-club-attendance",
    "label": "Kids Club Attendance",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "club",
  "title": "Club & Membership",
  "group": "Guest services",
  "icon": "Club",
  "tables": [
   {
    "schema": "club",
    "table": "MembershipType",
    "route": "club/club/membership-type",
    "label": "Membership Type",
    "ops": "All",
    "enums": {
     "Category": [
      "FULL",
      "ASSOCIATE",
      "SOCIAL",
      "CORPORATE",
      "JUNIOR",
      "SENIOR",
      "HONORARY"
     ],
     "BillingFrequency": [
      "MONTHLY",
      "QUARTERLY",
      "ANNUAL"
     ]
    }
   },
   {
    "schema": "club",
    "table": "Member",
    "route": "club/club/member",
    "label": "Member",
    "ops": "All",
    "enums": {
     "Status": [
      "APPLICANT",
      "ACTIVE",
      "SUSPENDED",
      "LAPSED",
      "RESIGNED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "club",
    "table": "AccessRight",
    "route": "club/club/access-right",
    "label": "Access Right",
    "ops": "All",
    "enums": {
     "AccessLevel": [
      "FULL",
      "LIMITED",
      "GUEST_ONLY",
      "NONE"
     ]
    }
   },
   {
    "schema": "club",
    "table": "MemberPreference",
    "route": "club/club/member-preference",
    "label": "Member Preference",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "MemberVisit",
    "route": "club/club/member-visit",
    "label": "Member Visit",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "MemberCharge",
    "route": "club/club/member-charge",
    "label": "Member Charge",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "MemberInvoice",
    "route": "club/club/member-invoice",
    "label": "Member Invoice",
    "ops": "All",
    "enums": {
     "InvoiceType": [
      "DUES",
      "JOINING",
      "EVENT",
      "MINIMUM_SPEND_SHORTFALL",
      "STATEMENT",
      "OTHER"
     ],
     "Status": [
      "DRAFT",
      "ISSUED",
      "PAID",
      "OVERDUE",
      "VOID"
     ]
    }
   },
   {
    "schema": "club",
    "table": "MemberPayment",
    "route": "club/club/member-payment",
    "label": "Member Payment",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "ReciprocalClub",
    "route": "club/club/reciprocal-club",
    "label": "Reciprocal Club",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "ReciprocalAgreement",
    "route": "club/club/reciprocal-agreement",
    "label": "Reciprocal Agreement",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "ReciprocalVisit",
    "route": "club/club/reciprocal-visit",
    "label": "Reciprocal Visit",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "club",
    "table": "ClubEvent",
    "route": "club/club/club-event",
    "label": "Club Event",
    "ops": "All",
    "enums": {
     "Status": [
      "PLANNED",
      "OPEN",
      "FULL",
      "COMPLETED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "club",
    "table": "ClubEventRegistration",
    "route": "club/club/club-event-registration",
    "label": "Club Event Registration",
    "ops": "All",
    "enums": {
     "Status": [
      "REGISTERED",
      "WAITLIST",
      "CANCELLED",
      "ATTENDED",
      "NO_SHOW"
     ]
    }
   }
  ]
 },
 {
  "key": "owners",
  "title": "Owners & HOA",
  "group": "Property",
  "icon": "Owners",
  "tables": [
   {
    "schema": "own",
    "table": "Unit",
    "route": "owners/own/unit",
    "label": "Unit",
    "ops": "All",
    "enums": {
     "UnitType": [
      "HOTEL_ROOM",
      "CONDO",
      "VILLA",
      "APARTMENT",
      "TOWNHOUSE",
      "RESIDENCE"
     ],
     "Status": [
      "ACTIVE",
      "OFF_PROGRAM",
      "SOLD",
      "UNDER_RENOVATION"
     ]
    }
   },
   {
    "schema": "own",
    "table": "Owner",
    "route": "owners/own/owner",
    "label": "Owner",
    "ops": "All",
    "enums": {
     "PayoutMethod": [
      "BANK_TRANSFER",
      "CHEQUE",
      "CREDIT_TO_ACCOUNT",
      "OTHER"
     ]
    }
   },
   {
    "schema": "own",
    "table": "Ownership",
    "route": "owners/own/ownership",
    "label": "Ownership",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "own",
    "table": "RentalProgram",
    "route": "owners/own/rental-program",
    "label": "Rental Program",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "own",
    "table": "OwnerContract",
    "route": "owners/own/owner-contract",
    "label": "Owner Contract",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "ACTIVE",
      "EXPIRED",
      "TERMINATED"
     ]
    }
   },
   {
    "schema": "own",
    "table": "OwnerStay",
    "route": "owners/own/owner-stay",
    "label": "Owner Stay",
    "ops": "All",
    "enums": {
     "StayKind": [
      "OWNER_USE",
      "OWNER_GUEST",
      "MAINTENANCE_BLOCK"
     ]
    }
   },
   {
    "schema": "own",
    "table": "OwnerStatement",
    "route": "owners/own/owner-statement",
    "label": "Owner Statement",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "APPROVED",
      "SENT",
      "PAID"
     ]
    }
   },
   {
    "schema": "own",
    "table": "OwnerStatementLine",
    "route": "owners/own/owner-statement-line",
    "label": "Owner Statement Line",
    "ops": "All",
    "enums": {
     "LineType": [
      "REVENUE",
      "COMMISSION",
      "EXPENSE",
      "HOA",
      "RESERVE",
      "ADJUSTMENT"
     ]
    }
   },
   {
    "schema": "own",
    "table": "OwnerExpense",
    "route": "owners/own/owner-expense",
    "label": "Owner Expense",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "own",
    "table": "HoaFee",
    "route": "owners/own/hoa-fee",
    "label": "Hoa Fee",
    "ops": "All",
    "enums": {
     "Basis": [
      "FIXED",
      "PER_SQM",
      "PER_SHARE"
     ],
     "Frequency": [
      "MONTHLY",
      "QUARTERLY",
      "ANNUAL"
     ]
    }
   },
   {
    "schema": "own",
    "table": "HoaCharge",
    "route": "owners/own/hoa-charge",
    "label": "Hoa Charge",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "INVOICED",
      "PAID",
      "WAIVED"
     ]
    }
   },
   {
    "schema": "own",
    "table": "ReserveFund",
    "route": "owners/own/reserve-fund",
    "label": "Reserve Fund",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "own",
    "table": "ReserveTransaction",
    "route": "owners/own/reserve-transaction",
    "label": "Reserve Transaction",
    "ops": "All",
    "enums": {
     "TxnType": [
      "CONTRIBUTION",
      "WITHDRAWAL",
      "INTEREST",
      "ADJUSTMENT"
     ]
    }
   }
  ]
 },
 {
  "key": "casino",
  "title": "Casino",
  "group": "Guest services",
  "icon": "Casino",
  "tables": [
   {
    "schema": "cas",
    "table": "Player",
    "route": "casino/cas/player",
    "label": "Player",
    "ops": "All",
    "enums": {
     "Tier": [
      "BASE",
      "BRONZE",
      "SILVER",
      "GOLD",
      "PLATINUM",
      "DIAMOND"
     ],
     "Status": [
      "ACTIVE",
      "SUSPENDED",
      "EXCLUDED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "PlayerRating",
    "route": "casino/cas/player-rating",
    "label": "Player Rating",
    "ops": "All",
    "enums": {
     "GameType": [
      "SLOTS",
      "BLACKJACK",
      "ROULETTE",
      "BACCARAT",
      "POKER",
      "CRAPS",
      "SPORTSBOOK",
      "OTHER"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "CompPolicy",
    "route": "casino/cas/comp-policy",
    "label": "Comp Policy",
    "ops": "All",
    "enums": {
     "MinTier": [
      "BASE",
      "BRONZE",
      "SILVER",
      "GOLD",
      "PLATINUM",
      "DIAMOND"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "CompAward",
    "route": "casino/cas/comp-award",
    "label": "Comp Award",
    "ops": "All",
    "enums": {
     "CompType": [
      "ROOM",
      "FNB",
      "SPA",
      "SHOW",
      "CASH_BACK",
      "FREE_PLAY",
      "TRANSPORT",
      "OTHER"
     ],
     "Status": [
      "ISSUED",
      "REDEEMED",
      "EXPIRED",
      "VOID"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "CageTransaction",
    "route": "casino/cas/cage-transaction",
    "label": "Cage Transaction",
    "ops": "Read|Create",
    "enums": {
     "TxnType": [
      "BUY_IN",
      "CASH_OUT",
      "FRONT_MONEY",
      "MARKER_ISSUE",
      "MARKER_PAYMENT",
      "CHIP_PURCHASE",
      "CHIP_REDEMPTION",
      "DEPOSIT",
      "WITHDRAWAL"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "Marker",
    "route": "casino/cas/marker",
    "label": "Marker",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "PARTIAL",
      "PAID",
      "DEFAULTED",
      "WRITTEN_OFF"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "ResponsibleGamingLimit",
    "route": "casino/cas/responsible-gaming-limit",
    "label": "Responsible Gaming Limit",
    "ops": "All",
    "enums": {
     "LimitType": [
      "DEPOSIT",
      "LOSS",
      "TIME",
      "WAGER"
     ],
     "LimitPeriod": [
      "DAILY",
      "WEEKLY",
      "MONTHLY"
     ],
     "SetBy": [
      "PLAYER",
      "OPERATOR",
      "REGULATOR"
     ],
     "Status": [
      "ACTIVE",
      "ENDED",
      "REVOKED"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "SelfExclusion",
    "route": "casino/cas/self-exclusion",
    "label": "Self Exclusion",
    "ops": "All",
    "enums": {
     "Scope": [
      "PROPERTY",
      "CHAIN",
      "NATIONAL"
     ],
     "Status": [
      "ACTIVE",
      "ENDED",
      "REVOKED"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "PlayerAlert",
    "route": "casino/cas/player-alert",
    "label": "Player Alert",
    "ops": "All",
    "enums": {
     "AlertType": [
      "AML_THRESHOLD",
      "HIGH_LOSS",
      "LONG_SESSION",
      "UNDERAGE",
      "EXCLUDED_ENTRY",
      "SUSPICIOUS_ACTIVITY"
     ]
    }
   },
   {
    "schema": "cas",
    "table": "RegulatoryReport",
    "route": "casino/cas/regulatory-report",
    "label": "Regulatory Report",
    "ops": "All",
    "enums": {
     "ReportType": [
      "CTR",
      "SAR",
      "DAILY_WIN_LOSS",
      "MONTHLY_GGR",
      "SELF_EXCLUSION",
      "OTHER"
     ],
     "Status": [
      "DRAFT",
      "SUBMITTED",
      "ACCEPTED",
      "REJECTED"
     ]
    }
   }
  ]
 },
 {
  "key": "retail",
  "title": "Retail & Gift Shops",
  "group": "Commerce",
  "icon": "Retail",
  "tables": [
   {
    "schema": "ret",
    "table": "Shop",
    "route": "retail/ret/shop",
    "label": "Shop",
    "ops": "All",
    "enums": {
     "ShopType": [
      "GIFT",
      "BOUTIQUE",
      "CONVENIENCE",
      "SPORTS",
      "DUTY_FREE",
      "BRANDED"
     ]
    }
   },
   {
    "schema": "ret",
    "table": "Category",
    "route": "retail/ret/category",
    "label": "Category",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "Product",
    "route": "retail/ret/product",
    "label": "Product",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "ShopStock",
    "route": "retail/ret/shop-stock",
    "label": "Shop Stock",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "StockMovement",
    "route": "retail/ret/stock-movement",
    "label": "Stock Movement",
    "ops": "All",
    "enums": {
     "MoveType": [
      "RECEIPT",
      "SALE",
      "RETURN",
      "ADJUSTMENT",
      "TRANSFER_OUT",
      "TRANSFER_IN",
      "WRITE_OFF"
     ]
    }
   },
   {
    "schema": "ret",
    "table": "PurchaseOrder",
    "route": "retail/ret/purchase-order",
    "label": "Purchase Order",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "ORDERED",
      "PARTIAL",
      "RECEIVED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "ret",
    "table": "PurchaseOrderLine",
    "route": "retail/ret/purchase-order-line",
    "label": "Purchase Order Line",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "Promotion",
    "route": "retail/ret/promotion",
    "label": "Promotion",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "Sale",
    "route": "retail/ret/sale",
    "label": "Sale",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "PAID",
      "ROOM_CHARGED",
      "VOID",
      "REFUNDED"
     ]
    }
   },
   {
    "schema": "ret",
    "table": "SaleLine",
    "route": "retail/ret/sale-line",
    "label": "Sale Line",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "Payment",
    "route": "retail/ret/payment",
    "label": "Payment",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "ret",
    "table": "SaleReturn",
    "route": "retail/ret/sale-return",
    "label": "Sale Return",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "transport",
  "title": "Transport & Transfers",
  "group": "Operations",
  "icon": "Transport",
  "tables": [
   {
    "schema": "trn",
    "table": "Vehicle",
    "route": "transport/trn/vehicle",
    "label": "Vehicle",
    "ops": "All",
    "enums": {
     "VehicleType": [
      "SEDAN",
      "SUV",
      "VAN",
      "MINIBUS",
      "BUS",
      "LIMO",
      "BOAT",
      "GOLF_CART"
     ],
     "Status": [
      "AVAILABLE",
      "IN_SERVICE",
      "MAINTENANCE",
      "RETIRED"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "Driver",
    "route": "transport/trn/driver",
    "label": "Driver",
    "ops": "All",
    "enums": {
     "Status": [
      "ACTIVE",
      "ON_LEAVE",
      "INACTIVE"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "TransportRoute",
    "route": "transport/trn/transport-route",
    "label": "Transport Route",
    "ops": "All",
    "enums": {
     "RouteType": [
      "AIRPORT",
      "SHUTTLE_LOOP",
      "ON_DEMAND",
      "TOUR",
      "CITY"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "RouteStop",
    "route": "transport/trn/route-stop",
    "label": "Route Stop",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "trn",
    "table": "ShuttleSchedule",
    "route": "transport/trn/shuttle-schedule",
    "label": "Shuttle Schedule",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "trn",
    "table": "TransferRate",
    "route": "transport/trn/transfer-rate",
    "label": "Transfer Rate",
    "ops": "All",
    "enums": {
     "VehicleType": [
      "SEDAN",
      "SUV",
      "VAN",
      "MINIBUS",
      "BUS",
      "LIMO",
      "BOAT",
      "GOLF_CART",
      "ANY"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "TransferBooking",
    "route": "transport/trn/transfer-booking",
    "label": "Transfer Booking",
    "ops": "All",
    "enums": {
     "TransferType": [
      "ARRIVAL",
      "DEPARTURE",
      "INTERNAL",
      "SHUTTLE_SEAT"
     ],
     "Status": [
      "REQUESTED",
      "CONFIRMED",
      "DISPATCHED",
      "PICKED_UP",
      "COMPLETED",
      "CANCELLED",
      "NO_SHOW"
     ],
     "ChargeMode": [
      "FOLIO",
      "PACKAGE",
      "COMPLIMENTARY",
      "CASH"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "Trip",
    "route": "transport/trn/trip",
    "label": "Trip",
    "ops": "All",
    "enums": {
     "Status": [
      "PLANNED",
      "ON_ROUTE",
      "COMPLETED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "trn",
    "table": "TripPassenger",
    "route": "transport/trn/trip-passenger",
    "label": "Trip Passenger",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "trn",
    "table": "VehicleServiceLog",
    "route": "transport/trn/vehicle-service-log",
    "label": "Vehicle Service Log",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "kitchen",
  "title": "Kitchen, Allergens & Production",
  "group": "Operations",
  "icon": "Kitchen",
  "tables": [
   {
    "schema": "kit",
    "table": "Allergen",
    "route": "kitchen/kit/allergen",
    "label": "Allergen",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "kit",
    "table": "DietaryAttribute",
    "route": "kitchen/kit/dietary-attribute",
    "label": "Dietary Attribute",
    "ops": "All",
    "enums": {
     "AttributeType": [
      "DIET",
      "RELIGIOUS",
      "LIFESTYLE",
      "MEDICAL"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "ItemAllergen",
    "route": "kitchen/kit/item-allergen",
    "label": "Item Allergen",
    "ops": "All",
    "enums": {
     "Presence": [
      "CONTAINS",
      "MAY_CONTAIN",
      "FREE_FROM"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "ItemDietaryAttribute",
    "route": "kitchen/kit/item-dietary-attribute",
    "label": "Item Dietary Attribute",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "kit",
    "table": "Station",
    "route": "kitchen/kit/station",
    "label": "Station",
    "ops": "All",
    "enums": {
     "StationType": [
      "HOT",
      "COLD",
      "PASTRY",
      "GRILL",
      "BAR",
      "BUTCHERY",
      "PREP",
      "PASS"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "ProductionPlan",
    "route": "kitchen/kit/production-plan",
    "label": "Production Plan",
    "ops": "All",
    "enums": {
     "MealPeriod": [
      "BREAKFAST",
      "LUNCH",
      "DINNER",
      "BANQUET",
      "ALL_DAY"
     ],
     "Status": [
      "DRAFT",
      "APPROVED",
      "IN_PROGRESS",
      "DONE"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "ProductionPlanLine",
    "route": "kitchen/kit/production-plan-line",
    "label": "Production Plan Line",
    "ops": "All",
    "enums": {
     "Status": [
      "PLANNED",
      "PREPPING",
      "READY",
      "SERVED"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "PrepList",
    "route": "kitchen/kit/prep-list",
    "label": "Prep List",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "IN_PROGRESS",
      "DONE"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "PrepListLine",
    "route": "kitchen/kit/prep-list-line",
    "label": "Prep List Line",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "kit",
    "table": "WasteLog",
    "route": "kitchen/kit/waste-log",
    "label": "Waste Log",
    "ops": "All",
    "enums": {
     "Reason": [
      "SPOILAGE",
      "OVERPRODUCTION",
      "PREP_ERROR",
      "RETURNED",
      "EXPIRED",
      "OTHER"
     ]
    }
   },
   {
    "schema": "kit",
    "table": "CostVariance",
    "route": "kitchen/kit/cost-variance",
    "label": "Cost Variance",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "kit",
    "table": "AllergenAlert",
    "route": "kitchen/kit/allergen-alert",
    "label": "Allergen Alert",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "safety",
  "title": "Safety & Incidents",
  "group": "Operations",
  "icon": "Safety",
  "tables": [
   {
    "schema": "saf",
    "table": "EscalationRule",
    "route": "safety/saf/escalation-rule",
    "label": "Escalation Rule",
    "ops": "All",
    "enums": {
     "MinSeverity": [
      "LOW",
      "MEDIUM",
      "HIGH",
      "CRITICAL"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "IncidentType",
    "route": "safety/saf/incident-type",
    "label": "Incident Type",
    "ops": "All",
    "enums": {
     "Category": [
      "GUEST_INJURY",
      "STAFF_INJURY",
      "FIRE",
      "THEFT",
      "SECURITY",
      "MEDICAL",
      "FOOD_SAFETY",
      "NATURAL_DISASTER",
      "IT_OUTAGE",
      "UTILITY_FAILURE",
      "OTHER"
     ],
     "DefaultSeverity": [
      "LOW",
      "MEDIUM",
      "HIGH",
      "CRITICAL"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "Incident",
    "route": "safety/saf/incident",
    "label": "Incident",
    "ops": "All",
    "enums": {
     "Severity": [
      "LOW",
      "MEDIUM",
      "HIGH",
      "CRITICAL"
     ],
     "Status": [
      "REPORTED",
      "INVESTIGATING",
      "ESCALATED",
      "MITIGATED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "IncidentParty",
    "route": "safety/saf/incident-party",
    "label": "Incident Party",
    "ops": "All",
    "enums": {
     "PartyRole": [
      "GUEST",
      "STAFF",
      "VISITOR",
      "CONTRACTOR",
      "WITNESS",
      "EMERGENCY_SERVICE"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "IncidentAction",
    "route": "safety/saf/incident-action",
    "label": "Incident Action",
    "ops": "All",
    "enums": {
     "ActionType": [
      "CORRECTIVE",
      "PREVENTIVE",
      "NOTIFICATION",
      "MEDICAL",
      "POLICE",
      "INSURANCE",
      "INVESTIGATION"
     ],
     "Status": [
      "OPEN",
      "IN_PROGRESS",
      "DONE",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "IncidentAttachment",
    "route": "safety/saf/incident-attachment",
    "label": "Incident Attachment",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "saf",
    "table": "EscalationEvent",
    "route": "safety/saf/escalation-event",
    "label": "Escalation Event",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "saf",
    "table": "EmergencyProcedure",
    "route": "safety/saf/emergency-procedure",
    "label": "Emergency Procedure",
    "ops": "All",
    "enums": {
     "Category": [
      "FIRE",
      "EVACUATION",
      "MEDICAL",
      "BOMB_THREAT",
      "CYBER",
      "WEATHER",
      "LOCKDOWN",
      "POWER_FAILURE",
      "OTHER"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "EmergencyProcedureStep",
    "route": "safety/saf/emergency-procedure-step",
    "label": "Emergency Procedure Step",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "saf",
    "table": "Drill",
    "route": "safety/saf/drill",
    "label": "Drill",
    "ops": "All",
    "enums": {
     "Outcome": [
      "PASS",
      "PARTIAL",
      "FAIL"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "RegulatoryReport",
    "route": "safety/saf/regulatory-report",
    "label": "Regulatory Report",
    "ops": "All",
    "enums": {
     "Status": [
      "PENDING",
      "SUBMITTED",
      "ACKNOWLEDGED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "saf",
    "table": "PostIncidentReview",
    "route": "safety/saf/post-incident-review",
    "label": "Post Incident Review",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "COMPLETED"
     ]
    }
   }
  ]
 },
 {
  "key": "sustainability",
  "title": "Sustainability",
  "group": "Operations",
  "icon": "Sustainability",
  "tables": [
   {
    "schema": "sus",
    "table": "Meter",
    "route": "sustainability/sus/meter",
    "label": "Meter",
    "ops": "All",
    "enums": {
     "ResourceType": [
      "ELECTRICITY",
      "WATER",
      "GAS",
      "DIESEL",
      "STEAM",
      "SOLAR",
      "COOLING"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "MeterReading",
    "route": "sustainability/sus/meter-reading",
    "label": "Meter Reading",
    "ops": "All",
    "enums": {
     "Source": [
      "MANUAL",
      "IOT",
      "BMS",
      "UTILITY_BILL"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "EmissionFactor",
    "route": "sustainability/sus/emission-factor",
    "label": "Emission Factor",
    "ops": "All",
    "enums": {
     "ResourceType": [
      "ELECTRICITY",
      "WATER",
      "GAS",
      "DIESEL",
      "STEAM",
      "SOLAR",
      "COOLING",
      "WASTE",
      "FOOD"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "CarbonReport",
    "route": "sustainability/sus/carbon-report",
    "label": "Carbon Report",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "FINAL"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "WasteStream",
    "route": "sustainability/sus/waste-stream",
    "label": "Waste Stream",
    "ops": "All",
    "enums": {
     "Category": [
      "FOOD",
      "RECYCLABLE",
      "GENERAL",
      "HAZARDOUS",
      "E_WASTE",
      "CHEMICAL",
      "LINEN",
      "OTHER"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "WasteRecord",
    "route": "sustainability/sus/waste-record",
    "label": "Waste Record",
    "ops": "All",
    "enums": {
     "DisposalMethod": [
      "LANDFILL",
      "RECYCLED",
      "COMPOSTED",
      "INCINERATED",
      "DONATED",
      "REUSED"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "Target",
    "route": "sustainability/sus/target",
    "label": "Target",
    "ops": "All",
    "enums": {
     "TargetType": [
      "ENERGY",
      "WATER",
      "WASTE",
      "CARBON"
     ],
     "Status": [
      "ACTIVE",
      "ACHIEVED",
      "MISSED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "Certification",
    "route": "sustainability/sus/certification",
    "label": "Certification",
    "ops": "All",
    "enums": {
     "Scheme": [
      "LEED",
      "GREEN_KEY",
      "EARTHCHECK",
      "ISO14001",
      "ISO50001",
      "BREEAM",
      "GSTC",
      "OTHER"
     ],
     "Status": [
      "PLANNED",
      "IN_PROGRESS",
      "CERTIFIED",
      "EXPIRED",
      "LAPSED"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "CertificationRequirement",
    "route": "sustainability/sus/certification-requirement",
    "label": "Certification Requirement",
    "ops": "All",
    "enums": {
     "Status": [
      "NOT_STARTED",
      "IN_PROGRESS",
      "MET",
      "NOT_MET"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "GreenProgram",
    "route": "sustainability/sus/green-program",
    "label": "Green Program",
    "ops": "All",
    "enums": {
     "ProgramType": [
      "LINEN_REUSE",
      "TOWEL_REUSE",
      "PAPERLESS",
      "REFILL",
      "CARBON_OFFSET",
      "LOCAL_SOURCING",
      "OTHER"
     ],
     "IncentiveType": [
      "NONE",
      "POINTS",
      "CREDIT",
      "DONATION"
     ]
    }
   },
   {
    "schema": "sus",
    "table": "GreenProgramParticipation",
    "route": "sustainability/sus/green-program-participation",
    "label": "Green Program Participation",
    "ops": "All",
    "enums": {}
   }
  ]
 },
 {
  "key": "franchise",
  "title": "Franchise & Brand Standards",
  "group": "Corporate",
  "icon": "Franchise",
  "tables": [
   {
    "schema": "frn",
    "table": "Franchisee",
    "route": "franchise/frn/franchisee",
    "label": "Franchisee",
    "ops": "All",
    "enums": {
     "Status": [
      "PROSPECT",
      "ACTIVE",
      "SUSPENDED",
      "TERMINATED"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "Agreement",
    "route": "franchise/frn/agreement",
    "label": "Agreement",
    "ops": "All",
    "enums": {
     "FeeBasis": [
      "ROOM_REVENUE",
      "TOTAL_REVENUE",
      "GOP"
     ],
     "Status": [
      "DRAFT",
      "ACTIVE",
      "EXPIRED",
      "TERMINATED"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "BrandStandard",
    "route": "franchise/frn/brand-standard",
    "label": "Brand Standard",
    "ops": "All",
    "enums": {
     "Category": [
      "SERVICE",
      "CLEANLINESS",
      "BRANDING",
      "FOOD_BEVERAGE",
      "SAFETY",
      "DIGITAL",
      "SUSTAINABILITY",
      "OTHER"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "BrandAudit",
    "route": "franchise/frn/brand-audit",
    "label": "Brand Audit",
    "ops": "All",
    "enums": {
     "AuditType": [
      "SCHEDULED",
      "UNANNOUNCED",
      "MYSTERY_GUEST",
      "FOLLOW_UP"
     ],
     "Result": [
      "PASS",
      "CONDITIONAL",
      "FAIL",
      "PENDING"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "BrandAuditFinding",
    "route": "franchise/frn/brand-audit-finding",
    "label": "Brand Audit Finding",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "frn",
    "table": "FeeStatement",
    "route": "franchise/frn/fee-statement",
    "label": "Fee Statement",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "ISSUED",
      "PAID",
      "DISPUTED"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "PropertyParticipation",
    "route": "franchise/frn/property-participation",
    "label": "Property Participation",
    "ops": "All",
    "enums": {
     "ProgramType": [
      "LOYALTY",
      "CRS",
      "GDS",
      "OTA_PARITY",
      "CENTRAL_RESERVATIONS",
      "MARKETING_FUND"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "FranchiseeReport",
    "route": "franchise/frn/franchisee-report",
    "label": "Franchisee Report",
    "ops": "All",
    "enums": {
     "Status": [
      "DUE",
      "SUBMITTED",
      "LATE",
      "ACCEPTED"
     ]
    }
   },
   {
    "schema": "frn",
    "table": "ComplianceNotice",
    "route": "franchise/frn/compliance-notice",
    "label": "Compliance Notice",
    "ops": "All",
    "enums": {
     "NoticeType": [
      "WARNING",
      "BREACH",
      "CURE_PERIOD",
      "TERMINATION"
     ],
     "Status": [
      "OPEN",
      "CURED",
      "ESCALATED",
      "CLOSED"
     ]
    }
   }
  ]
 },
 {
  "key": "distribution",
  "title": "Distribution & Content",
  "group": "Corporate",
  "icon": "Distribution",
  "tables": [
   {
    "schema": "dst",
    "table": "GdsConnection",
    "route": "distribution/dst/gds-connection",
    "label": "Gds Connection",
    "ops": "All",
    "enums": {
     "Gds": [
      "AMADEUS",
      "SABRE",
      "TRAVELPORT",
      "OTHER"
     ],
     "Status": [
      "TESTING",
      "ACTIVE",
      "INACTIVE",
      "ERROR"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "GdsRateMap",
    "route": "distribution/dst/gds-rate-map",
    "label": "Gds Rate Map",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "dst",
    "table": "InventorySource",
    "route": "distribution/dst/inventory-source",
    "label": "Inventory Source",
    "ops": "All",
    "enums": {
     "SourceType": [
      "DIRECT",
      "GDS",
      "OTA",
      "WHOLESALER",
      "BED_BANK",
      "CORPORATE_PORTAL"
     ],
     "AllocationRule": [
      "SHARED",
      "ALLOTMENT",
      "STOP_SELL"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "InventoryAllotment",
    "route": "distribution/dst/inventory-allotment",
    "label": "Inventory Allotment",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "dst",
    "table": "ContentAsset",
    "route": "distribution/dst/content-asset",
    "label": "Content Asset",
    "ops": "All",
    "enums": {
     "AssetType": [
      "PHOTO",
      "VIDEO",
      "FLOOR_PLAN",
      "VIRTUAL_TOUR"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "ContentDescription",
    "route": "distribution/dst/content-description",
    "label": "Content Description",
    "ops": "All",
    "enums": {
     "ContentKey": [
      "OVERVIEW",
      "AMENITIES",
      "POLICIES",
      "LOCATION",
      "ROOM_DESCRIPTION",
      "DINING",
      "ACTIVITIES"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "ContentPublication",
    "route": "distribution/dst/content-publication",
    "label": "Content Publication",
    "ops": "All",
    "enums": {
     "Status": [
      "PENDING",
      "PUBLISHED",
      "REJECTED"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "MetasearchProgram",
    "route": "distribution/dst/metasearch-program",
    "label": "Metasearch Program",
    "ops": "All",
    "enums": {
     "Provider": [
      "GOOGLE_HOTEL_ADS",
      "TRIVAGO",
      "KAYAK",
      "TRIPADVISOR",
      "SKYSCANNER",
      "OTHER"
     ],
     "Status": [
      "PLANNED",
      "ACTIVE",
      "PAUSED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "MetasearchPerformance",
    "route": "distribution/dst/metasearch-performance",
    "label": "Metasearch Performance",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "dst",
    "table": "DirectApiPartner",
    "route": "distribution/dst/direct-api-partner",
    "label": "Direct Api Partner",
    "ops": "All",
    "enums": {
     "PartnerType": [
      "META",
      "AGGREGATOR",
      "WHITE_LABEL",
      "MOBILE_APP",
      "CORPORATE"
     ],
     "Scope": [
      "SHOPPING",
      "BOOKING",
      "BOTH"
     ]
    }
   },
   {
    "schema": "dst",
    "table": "ChannelPerformanceDaily",
    "route": "distribution/dst/channel-performance-daily",
    "label": "Channel Performance Daily",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "dst",
    "table": "DistributionRule",
    "route": "distribution/dst/distribution-rule",
    "label": "Distribution Rule",
    "ops": "All",
    "enums": {
     "RuleType": [
      "RESTRICTION",
      "MARKUP",
      "PARITY",
      "CUTOFF"
     ]
    }
   }
  ]
 },
 {
  "key": "verticals",
  "title": "Resort, Cruise, Venue & Serviced Apartments",
  "group": "Property",
  "icon": "Verticals",
  "tables": [
   {
    "schema": "vrt",
    "table": "TimeshareProgram",
    "route": "verticals/vrt/timeshare-program",
    "label": "Timeshare Program",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "TimeshareAccount",
    "route": "verticals/vrt/timeshare-account",
    "label": "Timeshare Account",
    "ops": "All",
    "enums": {
     "Status": [
      "ACTIVE",
      "SUSPENDED",
      "EXPIRED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "TimeshareLedger",
    "route": "verticals/vrt/timeshare-ledger",
    "label": "Timeshare Ledger",
    "ops": "All",
    "enums": {
     "Reason": [
      "ANNUAL_GRANT",
      "STAY_REDEMPTION",
      "EXPIRY",
      "ADJUSTMENT",
      "PURCHASE",
      "TRANSFER"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "Vessel",
    "route": "verticals/vrt/vessel",
    "label": "Vessel",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "CabinCategory",
    "route": "verticals/vrt/cabin-category",
    "label": "Cabin Category",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "Cabin",
    "route": "verticals/vrt/cabin",
    "label": "Cabin",
    "ops": "All",
    "enums": {
     "Status": [
      "AVAILABLE",
      "OCCUPIED",
      "OUT_OF_ORDER"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "Voyage",
    "route": "verticals/vrt/voyage",
    "label": "Voyage",
    "ops": "All",
    "enums": {
     "Status": [
      "PLANNED",
      "OPEN_FOR_SALE",
      "SAILING",
      "COMPLETED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "VoyageStop",
    "route": "verticals/vrt/voyage-stop",
    "label": "Voyage Stop",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "CruiseBooking",
    "route": "verticals/vrt/cruise-booking",
    "label": "Cruise Booking",
    "ops": "All",
    "enums": {
     "Status": [
      "BOOKED",
      "CONFIRMED",
      "EMBARKED",
      "DISEMBARKED",
      "CANCELLED",
      "NO_SHOW"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "CruisePassenger",
    "route": "verticals/vrt/cruise-passenger",
    "label": "Cruise Passenger",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "OnboardAccount",
    "route": "verticals/vrt/onboard-account",
    "label": "Onboard Account",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "SETTLED",
      "CLOSED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "OnboardCharge",
    "route": "verticals/vrt/onboard-charge",
    "label": "Onboard Charge",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "ConferenceEvent",
    "route": "verticals/vrt/conference-event",
    "label": "Conference Event",
    "ops": "All",
    "enums": {
     "Status": [
      "PLANNING",
      "CONFIRMED",
      "RUNNING",
      "DONE",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "ConferenceSession",
    "route": "verticals/vrt/conference-session",
    "label": "Conference Session",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "Exhibitor",
    "route": "verticals/vrt/exhibitor",
    "label": "Exhibitor",
    "ops": "All",
    "enums": {
     "Status": [
      "INVITED",
      "CONFIRMED",
      "SET_UP",
      "DEPARTED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "Booth",
    "route": "verticals/vrt/booth",
    "label": "Booth",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "ExhibitorServiceOrder",
    "route": "verticals/vrt/exhibitor-service-order",
    "label": "Exhibitor Service Order",
    "ops": "All",
    "enums": {
     "ServiceType": [
      "POWER",
      "INTERNET",
      "FURNITURE",
      "AV",
      "SECURITY",
      "CLEANING",
      "SHIPPING",
      "CATERING",
      "OTHER"
     ],
     "Status": [
      "REQUESTED",
      "CONFIRMED",
      "DELIVERED",
      "CANCELLED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "ExtendedStayContract",
    "route": "verticals/vrt/extended-stay-contract",
    "label": "Extended Stay Contract",
    "ops": "All",
    "enums": {
     "Status": [
      "DRAFT",
      "ACTIVE",
      "ENDED",
      "TERMINATED"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "UtilityMeter",
    "route": "verticals/vrt/utility-meter",
    "label": "Utility Meter",
    "ops": "All",
    "enums": {
     "UtilityType": [
      "ELECTRICITY",
      "WATER",
      "GAS",
      "INTERNET",
      "COOLING"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "UtilityReading",
    "route": "verticals/vrt/utility-reading",
    "label": "Utility Reading",
    "ops": "All",
    "enums": {}
   },
   {
    "schema": "vrt",
    "table": "UtilityBill",
    "route": "verticals/vrt/utility-bill",
    "label": "Utility Bill",
    "ops": "All",
    "enums": {
     "Status": [
      "OPEN",
      "POSTED",
      "PAID"
     ]
    }
   },
   {
    "schema": "vrt",
    "table": "ApartmentHousekeepingPlan",
    "route": "verticals/vrt/apartment-housekeeping-plan",
    "label": "Apartment Housekeeping Plan",
    "ops": "All",
    "enums": {
     "ServiceType": [
      "LIGHT_CLEAN",
      "FULL_CLEAN",
      "LINEN_CHANGE",
      "DEEP_CLEAN"
     ]
    }
   }
  ]
 }
];
